import { ToastContextDispatch } from "Context/CommonContext";
import { LOPDashboardContext, MyBranchContext } from "Context/LOPDashboard";
import useMasterContext from "Context/MasterContext";
import BranchHealthHeader from "Pages/BranchHealth/BranchHealthHeader";
import BranchHealthTable from "Pages/BranchHealth/BranchHealthTable";
import BranchhealthTip from "Pages/BranchHealth/BranchHealthTip";
import BranchStudentFilter from "Pages/BranchHealth/Student/BranchStudentFilter";
import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Card } from "reactstrap";
import {
  BASE_URL,
  MY_BRANCH_LIST,
  MY_BRANCH_STUDENT_LIST,
} from "utilFunctions/Constants/urlConstants";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import { removeEmptyFields } from "utilFunctions/helperFunctions/HelperFunction";
import Paginator from "utilFunctions/shared/Paginator";

const SORT_ASC = "ASC";

const BranchStudentTableHeading = [
  { label: "Student Name", value: "name" },
  { label: "PSID", value: "psid" },
  { label: "Course ID", value: "courseId" },
  { label: "Batch", value: "batch" },
  { label: "Risk Segment", value: "segment" },
  { label: "LOP %", value: "probability" },
  { label: "Status", value: "status" },
  { label: "Followups", value: "followUpCount" },
];
function BranchStudentHome() {
  const { screen }: any = useWindowSize();
  const { masters } = useMasterContext();
  const location = useLocation();
  const { state } = location;
  const ToastDispatch = useContext(ToastContextDispatch);
  const { myBranch, setMyBranch } = useContext(MyBranchContext);
  const { LOPDashboard } = useContext<any>(LOPDashboardContext);
  const [sortOrder, setSortOrder] = useState(SORT_ASC);
  const [sortColumn, setSortColumn] = useState<any>("student_name");
  const [filterState, setFilterState] = useState<any>({
    stream:
      state?.filterState?.stream != undefined
        ? state?.filterState?.stream
        : masters.streams && masters.streams[0] != undefined
        ? masters.streams[0]
        : null,
    segment: null,
    status: null,
  });
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [pagination, setPagination] = useState({
    totalCount: "",
    totalPage: "",
    currentPage: "",
    nextPage: "",
    nextPageUrl: "",
    previousPageUrl: "",
  });
  const [BranchStudentData, setBranchStudentData] = useState<any>([]);
  const [businessUnit, setbusinessUnit] = useState<string>("");
  const [stream, setStream] = useState<any>({});
  const [studentAggregatedData, setStudentAggregatedData] = useState<any>([]);
  const { makeRequest: GetBranchStudentData, loading: tableloading } =
    useGetApi(
      (data: any) => {
        console.log("data=====", data);
        if (data["data"] && data["data"].length) {
          setBranchStudentData(data["data"] || []);
          setPagination({
            totalCount: data.totalCount,
            totalPage: data.totalPage,
            currentPage: data.currentPage,
            nextPage: data?.nextPage ? data.nextPage : 0,
            previousPageUrl: data?.previousPageUrl ? data.previousPageUrl : "",
            nextPageUrl: data?.nextPageUrl ? data.nextPageUrl : "",
          });
        } else {
          setBranchStudentData([]);
        }
      },
      (error: any) => {
        setBranchStudentData([]);
        if (
          error &&
          error["response"] &&
          error["response"]["data"] &&
          error["response"]["data"]["internalCode"] &&
          error["response"]["data"]["internalCode"] != "1008"
        ) {
          ToastDispatch({
            isOpen: true,
            type: "Error",
            message: error.message,
          });
        } else if (
          error &&
          error["response"] &&
          error["response"]["data"] &&
          error["response"]["data"]["code"] == "NF"
        ) {
          ToastDispatch({
            isOpen: true,
            type: "Error",
            message: "No record found",
          });
        }
      }
    );
  const {
    makeRequest: GetBranchAggregatedData,
    loading: aggregatedDataLoading,
  } = useGetApi(
    (data) => {
      if (data && data["data"] && data["data"].length && data["data"][0]) {
        const aggregatedDataArray = Object.entries(data["data"][0]).map(
          ([key, label]) => ({
            label: key,
            value: label,
          })
        );
        setStudentAggregatedData(aggregatedDataArray || []);
      } else {
        setStudentAggregatedData([]);
      }
    },
    (error) => {
      setStudentAggregatedData([]);
      if (error && error["message"]) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: error.message,
        });
      } else if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["code"] == "NF"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: "No record found",
        });
      }
    }
  );

  useEffect(() => {
    if (Object.keys(myBranch).length) {
      const selectedBranch = state ? state.selectedBranch : null;
      const branchCode = selectedBranch?.branchCode
        ? selectedBranch?.branchCode
        : location.pathname.split("/")[location.pathname.split("/").length - 1];
      applyFilter(myBranch, branchCode);
    } else {
      if (masters.streams && masters.streams) {
        const filterLength = Object.values(filterState).filter(
          (ele) => ele != null
        ).length;
        const selectedBranch = state ? state.selectedBranch : null;
        const streamObj = masters?.streams?.find(
          (item: any) => item.label === "SOE"
        );
        const streamName =
          state?.filterState?.stream != undefined
            ? state?.filterState?.stream?.label
            : masters.streams && masters.streams[0] != undefined
            ? masters.streams[0]?.label
            : null;
        const branchCode = selectedBranch?.branchCode
          ? selectedBranch?.branchCode
          : location.pathname.split("/")[
              location.pathname.split("/").length - 1
            ];
        if (streamName && streamName != null) {
          setStream(streamObj);
          setbusinessUnit(branchCode);
          const url =
            BASE_URL +
            MY_BRANCH_STUDENT_LIST +
            "?sortBy=" +
            sortColumn +
            "&sortDir=" +
            sortOrder;
          if (filterLength) {
            if (branchCode) {
              const obj = { ...filterState };
              if (LOPDashboard.clazz) {
                obj["clazz"] = LOPDashboard.clazz;
              }
              applyFilter(obj, branchCode);
            }
          } else {
            GetBranchStudentData(
              `${url}&stream=${streamName}&businessUnit=${branchCode}&offset=${0}&limit=${limit}`
            );
            const aggregatedurl = BASE_URL + MY_BRANCH_LIST;
            GetBranchAggregatedData(
              `${aggregatedurl}?stream=${streamName}&branchCode=${branchCode}&limit=${limit}&offset=${0}`
            );
          }
        }
      }
    }
  }, [
    masters?.streams,
    currentPage,
    limit,
    sortColumn,
    sortOrder,
    LOPDashboard,
    myBranch,
  ]);

  useEffect(() => {
    if (Object.keys(myBranch).length) {
      setFilterState({
        ...filterState,
        stream:
          myBranch?.stream != undefined
            ? myBranch?.stream
            : masters.streams && masters.streams[0] != undefined
            ? masters.streams[0]
            : null,
        segment: myBranch && myBranch.segment != null ? myBranch.segment : null,
        status: myBranch && myBranch.status != null ? myBranch.status : null,
        clazz:
          myBranch && myBranch.clazz != null
            ? myBranch.clazz
            : LOPDashboard && LOPDashboard.clazz
            ? LOPDashboard.clazz
            : null,
      });
    } else {
      setFilterState({
        stream:
          state?.filterState?.stream != undefined
            ? state?.filterState?.stream
            : masters.streams && masters.streams[0] != undefined
            ? masters.streams[0]
            : null,
        segment: null,
        status: null,
        clazz: LOPDashboard && LOPDashboard.clazz ? LOPDashboard.clazz : null,
      });
    }
  }, [masters?.streams, LOPDashboard]);
  const applyFilter = (filterStateObj: any, businessUnit?: string) => {
    const filterLength = Object.values(filterStateObj).filter(
      (ele) => ele != null
    ).length;
    if (filterLength) {
      const obj = {
        stream: filterStateObj.stream?.label,
        segment: filterStateObj.segment?.label,
        status: filterStateObj.status?.value,
        clazz: filterStateObj.clazz?.label,
      };
      const filters2: any = [];
      const formValues: any = removeEmptyFields(obj);
      for (const key in formValues) {
        if (Object.prototype.hasOwnProperty.call(formValues, key)) {
          if (formValues[key] != null && formValues[key] != "") {
            filters2.push(
              encodeURIComponent(key) +
                "=" +
                encodeURIComponent(formValues[key])
            );
          }
        }
      }
      let url = BASE_URL + MY_BRANCH_STUDENT_LIST;
      let aggregatedurl = BASE_URL + MY_BRANCH_LIST;
      if (Array.isArray(filters2) && filters2.length > 0) {
        url = url + "?" + filters2.join("&");
        aggregatedurl = aggregatedurl + "?" + filters2.join("&");
      }
      url = url + "&sortBy=" + sortColumn + "&sortDir=" + sortOrder;
      aggregatedurl =
        aggregatedurl + "&sortBy=" + sortColumn + "&sortDir=" + sortOrder;
      GetBranchStudentData(
        `${url}&businessUnit=${businessUnit}&limit=${limit}&offset=${0}`
      );
      GetBranchAggregatedData(
        `${aggregatedurl}&branchCode=${businessUnit}&limit=${limit}&offset=${0}`
      );
    }
  };
  const resetHandler = () => {
    const url = BASE_URL + MY_BRANCH_STUDENT_LIST;
    const streamName =
      state?.filterState?.stream != undefined
        ? state?.filterState?.stream?.label
        : masters.streams && masters.streams[0] != undefined
        ? masters.streams[0]?.label
        : null;
    GetBranchStudentData(
      `${url}?stream=${streamName}&businessUnit=${businessUnit}&offset=${0}&limit=${limit}`
    );
    setFilterState({
      stream:
        state?.filterState?.stream != undefined
          ? state?.filterState?.stream
          : masters.streams && masters.streams[0] != undefined
          ? masters.streams[0]
          : null,
      segment: null,
      status: null,
    });
    setMyBranch({});
  };
  const onLimitChange = (limit: number) => {
    setLimit(limit);
  };
  const onHandleSegmentSelection = (selected: any) => {
    let selectedSegmentName = "";
    console.log(selected, "onHandleSegmentSelection", filterState);
    if (selected == "moderateRisk") {
      selectedSegmentName = "Moderate";
    } else if (selected == "highRisk") {
      selectedSegmentName = "High";
    } else if (selected == "alarmingRisk") {
      selectedSegmentName = "Alarming";
    } else if (selected == "followUpCount") {
      selectedSegmentName = "FollowUp";
    } else {
      selectedSegmentName = "";
    }

    const segmentObj = {
      label: selectedSegmentName,
      value: selectedSegmentName,
      key: selectedSegmentName,
    };
    let filterStateObj;
    if (selectedSegmentName == "") {
      filterStateObj = { ...filterState, segment: null };
    } else {
      filterStateObj = { ...filterState, segment: segmentObj };
    }
    setFilterState(filterStateObj);
    applyFilter(filterStateObj, businessUnit);
  };
  console.log("onHandleSegmentSelection", filterState, stream);

  return (
    <>
      <BranchStudentFilter
        filterState={filterState}
        setFilterState={setFilterState}
        applyFilter={(filterValues: any) => {
          applyFilter(filterValues, businessUnit);
          setMyBranch(filterValues);
        }}
        resetHandler={resetHandler}
        location={location}
        businessUnit={businessUnit}
        studentAggregatedData={studentAggregatedData}
      />
      <BranchHealthHeader
        mode="studentHome"
        aggregatedData={studentAggregatedData}
        aggregatedDataLoading={aggregatedDataLoading}
        onHandleSegmentSelection={(selected: any) => {
          onHandleSegmentSelection(selected);
        }}
        filterState={filterState}
      />
      <BranchHealthTable
        mode="studentHome"
        tableloading={tableloading}
        tableData={BranchStudentData}
        tableHeading={BranchStudentTableHeading}
        sortColumn={sortColumn}
        sortOrder={sortOrder}
        setSortColumn={setSortColumn}
        setSortOrder={setSortOrder}
      />
      <div
        className={
          !["xs", "sm", "md"].includes(screen)
            ? "batchTableContainer pt-0 pb-1"
            : "ml-2 mr-2"
        }
      >
        <Card className="p-3 mt-1 mb-0">
          <Paginator
            module={"test"}
            pagination={pagination}
            pageChanged={(page: any) => setCurrentPage(page)}
            handlePaginationCall={(url: string) => {
              GetBranchStudentData(url);
            }}
            totalItems={BranchStudentData.length}
            limit={limit}
            onLimitChange={onLimitChange}
          />
        </Card>
      </div>
      <BranchhealthTip mode="studentHome" />
    </>
  );
}

export default BranchStudentHome;
